import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    statusPending: {
        id: 'swap.transaction_status.pending',
        defaultMessage: 'Swap is pending',
    },
    statusSuccess: {
        id: 'swap.transaction_status.successful',
        defaultMessage: 'Swap successful',
    },
    statusFailed: {
        id: 'swap.transaction_status.failed',
        defaultMessage: 'Swap failed',
    },
    detailsButton: {
        id: 'swap.transaction_status.details_button',
        defaultMessage: 'Details',
    },
    repeatButton: {
        id: 'swap.transaction_status.repeat_button',
        defaultMessage: 'Repeat',
    },
    closeButton: {
        id: 'swap.transaction_status.close_button',
        defaultMessage: 'Close',
    },
    tryAgainButton: {
        id: 'swap.transaction_status.try_again_button',
        defaultMessage: 'Try again',
    },
})
